import { api, ENDPOINTS } from '../config';
import type { Zone, ZoneFilters } from './types';

export async function getZone(filters?: ZoneFilters, zone_id?: string): Promise<Zone[] | Zone> {
  const response = await api.get(`${ENDPOINTS.ZONES}${zone_id ? `${zone_id}/` : ''}`, {
    params: filters,
  });
  
  return response.data;
}